import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Nav,
  NavbarBrand,
  Col, Row,
  NavbarToggler,
  NavItem,
  NavLink,
  Badge
} from 'reactstrap';
import HeaderDropdown from './HeaderDropdown';
import api from '../../api';
import apifunctions from '../../api/functions.js';
import logoParadigma from '../../../public/img/logoParadigma.png';

class Header extends Component {

  constructor(props) {
    super(props);
    this.state = {
      image: false,
    };
  }

  componentDidMount() {
    const successCallback = (response) => {
      if (response.data && response.data.image) {
        this.setState({ image: response.data.image });
      } else {
        this.setState({ image: false });
      }
    }
    const failureCallback = () => this.setState({ image: false });
    apifunctions.get(api.gestion.sitio.logoEmpresa, null, null, {}, successCallback, failureCallback, failureCallback);
  }

  sidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-hidden');
  }

  sidebarMinimize(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-minimized');
  }

  mobileSidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-mobile-show');
  }

  asideToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('aside-menu-hidden');
  }

  render() {
    return (
      <header className="app-header navbar">
      <NavbarToggler className="d-lg-none" onClick={this.mobileSidebarToggle}>
      <span className="navbar-toggler-icon"></span>
      </NavbarToggler>
        <NavbarBrand href="#">
          <Row className="h-100 m-0 p-0">
            <Col className="h-100 m-0 p-0 text-center">
              {
                this.state.image ?
                  <img src={this.state.image} className="logoEmpresa" alt="Logo Empresa" />
                  :
                  <img src={logoParadigma} className="logoEmpresa" alt="Logo Paradigma" />
              }
            </Col>
          </Row>
        </NavbarBrand>
        <NavbarToggler className="d-md-down-none d-none" onClick={this.sidebarToggle}>
        <span className="navbar-toggler-icon"></span>
        </NavbarToggler>
        <Nav className="ml-auto" navbar>
          <HeaderDropdown />
        </Nav>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js